var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedTeachers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1673 19.5V17.8333C16.1673 16.9493 15.8161 16.1014 15.191 15.4763C14.5659 14.8512 13.718 14.5 12.834 14.5H6.16732C5.28326 14.5 4.43542 14.8512 3.8103 15.4763C3.18517 16.1014 2.83398 16.9493 2.83398 17.8333V19.5",
    fill: "#1EB5F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1673 19.5V17.8333C16.1673 16.9493 15.8161 16.1014 15.191 15.4763C14.5659 14.8512 13.718 14.5 12.834 14.5H6.16732C5.28326 14.5 4.43542 14.8512 3.8103 15.4763C3.18517 16.1014 2.83398 16.9493 2.83398 17.8333V19.5",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49935 11.1667C11.3403 11.1667 12.8327 9.67428 12.8327 7.83333C12.8327 5.99238 11.3403 4.5 9.49935 4.5C7.6584 4.5 6.16602 5.99238 6.16602 7.83333C6.16602 9.67428 7.6584 11.1667 9.49935 11.1667Z",
    fill: "#1EB5F0",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.166 19.5001V17.8334C21.1655 17.0948 20.9196 16.3774 20.4672 15.7937C20.0147 15.2099 19.3811 14.793 18.666 14.6084",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.334 4.6084C16.051 4.79198 16.6865 5.20898 17.1403 5.79366C17.5942 6.37833 17.8405 7.09742 17.8405 7.83757C17.8405 8.57771 17.5942 9.2968 17.1403 9.88147C16.6865 10.4661 16.051 10.8831 15.334 11.0667",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedTeachers);
export default __webpack_public_path__ + "static/media/selected-teachers.425bdac2622514d65f1373cde8e5ead8.svg";
export { ForwardRef as ReactComponent };